import type { Building } from "building-types/building/buildingTypes";
import { makeElevationNotes } from "../generationTools/generateElevationNotesTools";
import makeGenerationStageComparator from "../utils/makeGenerationStageComparator";
import memo from "../utils/memo";

function select({
  levels,
  levelsAttributes,
  walls,
  rooms,
  elevationNoteEdgeBehaviors,
  mirror,
  datumAbstractions,
}: Pick<
  Building,
  "levels" | "levelsAttributes" | "walls" | "rooms" | "elevationNoteEdgeBehaviors" | "mirror" | "datumAbstractions"
>) {
  return {
    levels,
    levelsAttributes,
    walls,
    rooms,
    elevationNoteEdgeBehaviors,
    mirror,
    datumAbstractions,
  };
}

const compare = makeGenerationStageComparator<typeof select>({
  elevationNoteEdgeBehaviors: "shallow",
});

function generate({
  levels,
  levelsAttributes,
  walls,
  rooms,
  elevationNoteEdgeBehaviors,
  mirror,
  datumAbstractions,
}: ReturnType<typeof select>): Pick<Building, "elevationNotes"> {
  return {
    elevationNotes: makeElevationNotes(
      levels,
      levelsAttributes,
      datumAbstractions,
      elevationNoteEdgeBehaviors,
      rooms,
      walls,
      mirror,
    ),
  };
}

export default memo(select, generate, compare);
